const auth = (axios) => {
  return {

    /**
         * @param params
         * @method post
         * @api /api/auth/auth
         */
    checkAccountData (params) {
      return axios.post('/auth', params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/user/approved
         */
    confirmEmail (params) {
      return axios.post('/user/approved', params)
        .then((response) => response);
    },

    /**
         * @params params
         * @method post
         * @api /api/user/restorepasswordrequest
         */
    restorePassword (params) {
      return axios.post('/user/restorepasswordrequest', params)
        .then((response) => response);
    },
  };
};

export default auth;
